import Chart from "devextreme/viz/chart";

import saveAs from 'file-saver'
import { Workbook } from 'exceljs';
import { revokePlatformToken } from "./localStorageHelper";
import { signOut } from "supertokens-auth-react/recipe/thirdparty";

function handleClick(selector, e) {

    var chart = document.querySelector(selector);
    // Leaving "e" in here as its a good shout and could be useful in future.
    if (chart) {
        chart.classList.remove("fullscreen");

        // Cant think of a better way at the moment :(
        chart.style.height = localStorage.getItem("chartHeight") + "px";
        chart.style.width = localStorage.getItem("chartWidth") + "px";
        
        let instance = Chart.getInstance(chart);
        if (instance) {
            instance.render(true);
        }

        var elem = document.querySelector("div .fullscreen-tooltip");
        if (elem) {
            elem.classList.add("d-none");
        }    

        chart.removeAttribute("style");
    }
}

export const renderFullScreen = (selector) => {

    // :( cant think of a better way and its a bit hacky but we need the original width and height of the container
    // for the reset. 

    var chart = document.querySelector(selector);
    localStorage.setItem("chartWidth", chart.offsetWidth);
    localStorage.setItem("chartHeight", chart.offsetHeight);

    if (chart) {
        chart.classList.add("fullscreen");
        chart.addEventListener("click", (e) => handleClick(selector, e), { passive: true });

        let instance = Chart.getInstance(chart);        
        if (instance) {
            instance.render(true);
        }

        var elem = document.querySelector("div .fullscreen-tooltip");
        if (elem) {
            elem.classList.remove("d-none");
        }
    }
}

export const exportData = (ExportID, Data, Range = null, isWorkflow = true, workflowInstance) => {
    const workbook = new Workbook()
    const worksheet = workbook.addWorksheet(Range === null ? ExportID : `${isWorkflow === true ? '' : workflowInstance + '-WF-'}${ExportID}-${Range}`)

    let headerColumns = []
    for (const header in Data[0]) {
        headerColumns.push({ header: header, key: header, width: "20"})
    }
    worksheet.columns = headerColumns;

    worksheet.addRows(Data);
    workbook.xlsx.writeBuffer().then(function(buffer) {
        saveAs(new Blob([buffer], { type: "application/octet-stream" }), 
            `${isWorkflow === true ? '' : workflowInstance + '-WF-'}${Range === null ? ExportID : `${ExportID}-${Range}-Days`}-${Date.now()}.xlsx`
        )
    })
}

export async function onLogout() {
    await revokePlatformToken();
    await signOut();
}